import { Box, Button, Typography, Chip } from '@mui/material'
import React from 'react'
import { IWayToEarn } from '../../types/leaderboardTypes'

interface WaysToEarnPointsProps {
  mt?: number
  wayToEarnList: IWayToEarn[]
  onWayClick: (way: IWayToEarn) => void
}

const WaysToEarnPoints: React.FC<WaysToEarnPointsProps> = ({
  mt = 6,
  wayToEarnList,
  onWayClick,
}) => {
  return (
    <Box
      mt={{ xs: 2, md: mt }}
      minHeight={0}
      display="flex"
      flexDirection="column"
      height="100%"
    >
      <Typography variant="body2" mb={{ xs: 2, md: 3 }}>
        Ways to Earn Points
      </Typography>

      <Box
        display="flex"
        flexDirection="column"
        gap={1}
        overflow={'auto'}
        flexGrow={1}
      >
        {wayToEarnList.map((item, index) => {
          const isDisabled = item.status === 'disabled'
          return (
            <Box
              key={index}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                px: { xs: 1, md: 2 },
                py: { xs: 0.75, md: 1.5 },
                borderRadius: '12px',
                border: 1,
                borderColor: 'grey.200',
                opacity: isDisabled ? 0.6 : 1,
                cursor: isDisabled ? 'default' : 'auto',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
                <Typography variant="subtitle1"> {item.title}</Typography>
                {isDisabled && (
                  <Chip
                    label="Coming soon"
                    size="small"
                    sx={{
                      backgroundColor: 'transparent',
                      borderColor: 'grey.300',
                      color: 'text.secondary',
                      border: 1,
                      fontWeight: 400,
                      fontSize: '11px',
                      height: '24px',
                    }}
                  />
                )}
              </Box>

              <Button
                variant="outlined"
                sx={{
                  backgroundColor: (item.status === 'earned' || item.status === 'claimed' || item.earned) ? 'success.100' : 'transparent',
                  borderColor: (item.status === 'earned' || item.status === 'claimed' || item.earned) ? 'success.300' : 'grey.300',
                  color: 'primary.light',
                  height: '34px',
                  fontSize: '12px',
                  fontWeight: 400,
                  opacity: isDisabled ? 0.6 : 1,
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  '&.MuiButton-root': {
                    '&:hover': {
                      backgroundColor: (item.status === 'earned' || item.status === 'claimed' || item.earned) ? 'success.300' : undefined,
                    },
                  },
                }}
                onClick={() => {
                  if (!isDisabled) {
                    onWayClick(item)
                  }
                }}
                disabled={isDisabled}
              >
                {item.action}
              </Button>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default WaysToEarnPoints
